import React from 'react'
import loadingIcon from '../../images/icons/misc/loading.png'

const Loading = () => {

    return (
        <div className="w-screen h-screen flex justify-center items-center">
            <img className="animate-spin-slow" src={loadingIcon} alt="loading" />
        </div>
    )

}

export default Loading
